<template>
  <el-descriptions title="处方详情" :column="4" border>
    <!--    <template #extra>-->
    <!--      <el-button-->
    <!--        type="primary"-->
    <!--        size="small"-->
    <!--        @click="handleRowClick(row)"-->
    <!--      >选择-->
    <!--      </el-button>-->
    <!--    </template>-->
    <el-descriptions-item
      :span="2"
      label="名称"
    >{{ row.name }}
    </el-descriptions-item>
    <el-descriptions-item :span="2" label="方剂出处">{{
      row.prescriptionSource
    }}
    </el-descriptions-item>
    <el-descriptions-item :span="4" label="方剂内容">{{
      row.prescriptionContent
    }}
    </el-descriptions-item>
    <el-descriptions-item :span="4" label="方剂说明">{{
      row.prescriptionDescribe
    }}
    </el-descriptions-item>
    <el-descriptions-item
      label="用药天数"
    >{{ row.dayNum }}
    </el-descriptions-item>
    <el-descriptions-item
      label="每日剂数"
    >{{ row.dayDoseNum }}
    </el-descriptions-item>
    <el-descriptions-item
      label="每日次数"
    >{{ row.dayFreq }}
    </el-descriptions-item>
    <el-descriptions-item
      label="剂数"
    >{{ row.doseNum }}
    </el-descriptions-item>
    <el-descriptions-item
      label="代加工"
    >{{ row.decoctSign|DecoctSignType }}
    </el-descriptions-item>
  </el-descriptions>
</template>
<script>
import { getById } from "@/api/ik/data/dataApi"

export default {
  name: "TcmDetail",
  filters: {
    /**
     * 代加工类型
     * @param val
     * @returns {string}
     * @constructor
     */
    DecoctSignType(val) {
      switch (val) {
        case "00":
          return "不加工"
        case "01":
          return "代煎"
        case "11":
          return "制粒"
        case "21":
          return "细粉打粉"
        case "22":
          return "粗粉打粉"
        case "31":
          return "水丸制丸"
        case "32":
          return "蜜丸制丸"
        case "33":
          return "大蜜丸制丸"
        case "34":
          return "浓缩丸制丸"
        case "35":
          return "水蜜丸制丸"
        case "41":
          return "制瓶装膏"
        case "42":
          return "制袋装膏"
        case "43":
          return "制块装膏"
        default:
          return ""
      }
    }
  },
  props: {
    row: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  methods: {
    /**
     * 行被点击
     * @param row
     */
    handleRowClick(row) {
      getById(this.url, row.id)
        .then(res => {
          this.$emit("onPopupClick", res.data)
          this.visiable = false
        })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
